<template>
  <div>
    <div v-show="!startup.id">
      <template v-if="!registered">
        <RegisterStartupForm
          v-if="program"
          v-show="!registered"
          :program="program"
          :show-already-button="!registered && !startupAlreadyAdded"
          @registered="onRegister()"
        />
      </template>

      <div v-show="registered" class="animated fadeInUp">
        <p class="text-success">
          Thank you for registering. We’ve sent you the message with an
          activation link. Please check your mailbox.
        </p>
      </div>
    </div>

    <div v-show="startup.id">
      <button
        v-show="!registered && !startupAlreadyAdded"
        class="btn btn-primary btn-block"
        :disabled="inProgress"
        :loading="inProgress"
        @click="apply()"
      >
        <Spinner v-if="inProgress" />
        Apply with "{{ startup.name }}"
      </button>

      <div v-show="startupAlreadyAdded" class="animated fadeInUp">
        <p class="text-success">You have already applied to this program.</p>
        <router-link class="btn btn-primary" :to="applicationRoute">
          {{ goToApplicationLabelText }}
        </router-link>
      </div>

      <div v-show="registered" class="animated fadeInUp">
        <p class="text-success">
          Thank you for your interest! Please, go to My Applications section to
          submit your application.
        </p>
        <router-link class="btn btn-primary" :to="applicationRoute">
          {{ goToApplicationLabelText }}
        </router-link>
      </div>

      <br />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RegisterStartupForm from './RegisterStartupForm'
import _ from 'lodash'
import notifications from '@/services/notifications'
import http from '@/services/http'
import Spinner from '@/components/common/Spinner'
import { getNewAppUrl } from '@/utils/urls'

export default {
  components: { Spinner, RegisterStartupForm },
  props: {
    programId: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      organization: (state) => state.organizationDetails.organization,
      user: (state) => state.user.data,
      startup: (state) => _.first(state.user.data.startups) || {},
    }),
    activeProgramsMap() {
      const map = {}
      ;(this.organization.active_programs || []).forEach((p) => {
        map[p.id] = p
      })
      return map
    },
    program() {
      if (this.programId) {
        return this.activeProgramsMap[this.programId]
      } else if ((this.organization.active_programs || []).length > 0) {
        return this.organization.active_programs[0]
      } else {
        return null
      }
    },
    applicationRoute() {
      if (this.applicationId) {
        return {
          name: 'dashboardApplicationDetails',
          params: { id: this.applicationId },
        }
      } else {
        return {
          name: 'dashboardApplicationList',
        }
      }
    },
    goToApplicationLabelText() {
      if (this.applicationId) {
        return 'Go to application'
      } else {
        return 'Go to applications'
      }
    },
  },
  data() {
    return {
      registered: false,
      startupAlreadyAdded: false,
      applicationId: null,
      inProgress: false,
    }
  },
  methods: {
    onRegister(data = {}) {
      this.applicationId = data.application_id
      this.registered = true

      const url = this.$router.resolve({
        name: this.$route.name,
        query: {
          ...this.$route.query,
          finished: true,
        },
      })
      window.location = getNewAppUrl(url)
    },
    async apply() {
      this.inProgress = true
      const url = `/organizations/${this.organization.id}/register-existing-startup`
      if (!this.program || !this.program.id) {
        throw new Error(
          `=> No active program for organization ${this.organization.name} [${this.organization.id}]`,
        )
      }
      const data = {
        startup_id: this.startup.id,
        program_id: this.program.id,
      }
      try {
        const response = await http.postAuthed(url, data)
        this.onRegister(response.data)
      } catch (error) {
        if (!error || !error.response) {
          throw new Error('Unhandled exception')
        }
        const fieldErrors = error.response.data
        if (
          fieldErrors &&
          fieldErrors.startup_id &&
          fieldErrors.startup_id.length
        ) {
          const startupIdErrors = new Set(fieldErrors.startup_id)
          if (startupIdErrors.has('STARTUP_ALREADY_ADDED')) {
            this.startupAlreadyAdded = true
            this.applicationId = (fieldErrors.application_id || [])[0]
            return
          }
        }
        notifications.notify({ title: 'Something went wrong.', type: 'danger' })
        throw error
      } finally {
        this.inProgress = false
      }
      notifications.notify({ title: 'Done!', type: 'success' })
    },
  },
}
</script>
